<template>
  <div class="dialog-container wt-dialog-container">
    <div class="post-consumables-view-page">
      <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ref="siteGoodsClistTable"></wt-form-table>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
    <SiteGoodsCedit :visible.sync="formDialogVisible" :formData="formData" @refreshData="$refs.siteGoodsClistTable.requestFormList()"></SiteGoodsCedit>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SiteGoodsCList',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITE_GOODS',
        formComponent: {
          list: { type: 'default', value: '/modules/siteGoods/siteGoodsList', params: { id: '' }},
          delete: { type: 'default', value: '/modules/siteGoods/siteGoodsDelete' },
          view: { componentName: 'SiteGoodsViewHistory', noRequest: true }
        },
        formInputsData: [],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '导出Excel',
            key: 'EXPORT',
            action: 'EXCEL',
            hidden: false,
            url: window.wtConst.BASE_API + '/modules/siteGoods/siteGoodsListImport',
            fileName: '商品维护',
            permission: 'EXPORT' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '商品编号', key: 'goodsNo', type: 'text' },
          { name: '商品标题', key: 'title', type: 'text' },
          { name: '积分', key: 'integral', type: 'text' },
          { name: '商品类型', key: 'typeName', type: 'text' },
          { name: '库存数量', key: 'inventory', type: 'text' },
          { name: '备注', key: 'remark', type: 'text' },
          { name: '加入时间', key: 'createTime', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' }],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonWidth: 180 }
      },
      currentIndex: -1,
      currentValue: '',
      detailFormButtons: {
        title: '站点商品',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      formDialogVisible: false,
      formData: {}
    }
  },
  created() {
    this.form.formComponent.list.params.id = this.detailFormData.id
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'ADD') { // 新增
          this.formData = {}
          this.formDialogVisible = true
        }
        if (data.item.action === 'EDIT') {
          this.formData = JSON.parse(JSON.stringify(data.row))
          this.formData.inventoryorg = data.row.inventory
          this.formDialogVisible = true
        }
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setSiteGoodsDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    toClickAction({ row, index }, type) {
      if (type === 'EDIT') {
        this.currentValue = row.value
        this.currentIndex = index
      }
      if (type === 'SAVE') {
        row.value = this.currentValue
        this.currentIndex = -1
      }
      if (type === 'CANCEL') {
        this.currentIndex = -1
      }
      console.log(index)
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.siteManage.siteDetailData
    })
  }
}
</script>

<style scoped>
.post-consumables-view-page {
  padding-top: 20px;
  background-color: #fff;
}
</style>
